module.exports = __webpack_public_path__ + "static/media/Oval_Diamonds.982549d0.jpg";